export default __webpack_public_path__ + "static/media/audisoft6.52e4bd8c.mov";